import React from 'react';
import { Link } from 'react-router-dom';
import pottery from '../images/pottery.jpg';
import metal from '../images/metalInv.jpg';
import wood from '../images/wood-art.jpg';

const inventory = {
  Pottery: { image: pottery, copy: 'Explore colorful Mexican pottery and hand-painted pieces.' },
  'Metal Art': { image: metal, copy: 'Browse decorative metal art for your home and garden.' },
  'Knick-knacks': { image: wood, copy: 'Discover wood art, gifts, and one-of-a-kind keepsakes.' },
};

export default function InventoryDemo({ category }) {
  const item = inventory[category];
  return <main className="inventory-demo">
    <h1>{category} Inventory</h1>
    <img src={item.image} alt={`${category} at Rojos`} />
    <p>{item.copy}</p>
    <p>This is a preview of the Rojos demo. Contact the shop for current selection and availability.</p>
    <Link to="/contacts">Contact Rojos</Link>
  </main>;
}
